import { useAuth } from "@/hooks/use-auth";
import { Loader2 } from "lucide-react";
import { Redirect, Route } from "wouter";

interface ProtectedRouteProps {
  path: string;
  component: React.ComponentType;
  adminOnly?: boolean;
}

export function ProtectedRoute({
  path,
  component: Component,
  adminOnly = false,
}: ProtectedRouteProps) {
  const { user, isLoading } = useAuth();

  // Wenn noch geladen wird, zeige Ladeanimation
  if (isLoading) {
    return (
      <Route path={path}>
        <div className="flex items-center justify-center min-h-screen">
          <Loader2 className="h-8 w-8 animate-spin text-primary" />
        </div>
      </Route>
    );
  }

  // Wenn nicht angemeldet, zur Login-Seite umleiten
  if (!user) {
    return (
      <Route path={path}>
        <Redirect to="/auth" />
      </Route>
    );
  }

  // Wenn Admin-Bereich und Benutzer kein Admin, zur Startseite umleiten
  // Lenient check: unterstützt 'ROLE_ADMIN', 'admin', PHP-serialisiert, etc.
  const isAdmin = user.roles ? (
    Array.isArray(user.roles)
      ? user.roles.some((r: string) => String(r).toLowerCase().includes('admin'))
      : String(user.roles).toLowerCase().includes('admin')
  ) : false;
  if (adminOnly && !isAdmin) {
    return (
      <Route path={path}>
        <Redirect to="/" />
      </Route>
    );
  }

  // Komponente rendern, wenn Benutzer angemeldet und Berechtigung hat
  return (
    <Route path={path}>
      <Component />
    </Route>
  );
}